import React from 'react';

const InvisibleSubmit = () => (
  <input type="submit" style={{ display: 'none' }} />
);
export { InvisibleSubmit };
